<template>
  <div class="col">
    <p>このウェブサイト、モバイルアプリケーション（「tobook.link」）およびウェブウィジェット（「Web-widget」）は、tobook.link s.r.o.（登録番号19608217）によって所有および運営されています。法的住所は、プラハ19900のPavla Beneshe 750/8です。</p>
    <h6 class="mt-1 mb-1">
      主要用語
    </h6>
    <ul>
      <li><b>ユーザー</b> - tobook.linkサイトおよびアプリケーションのすべてのユーザーを指します（「サービスプロバイダー」または「クライアント」）。</li>
      <li><b>サービスプロバイダー</b> - 登録ユーザーであり、tobook.linkの予約ページを通じて商品やサービスを販売するあなたのことです。</li>
      <li><b>クライアント</b> - サービスプロバイダーが提供するサービスを予約し、登録ユーザーでないあなたのことです。</li>
      <li><b>支払いプロバイダー</b> - サービスプロバイダーのサービスの支払いを処理する支払いシステムを意味します。</li>
      <li><b>取引手数料</b> - は、振替額に対して課されるパーセンテージです。詳細は<b-link :to="{name: 'pricing'}">条件</b-link>セクションでご覧いただけます。</li>
      <li><b>サービス料</b> - は、tobook.linkの予約システムを利用するためにクライアントに課される固定額です。詳細は<b-link :to="{name: 'pricing'}">条件</b-link>セクションで提供されています。</li>
    </ul>
    <p>本規約（「規約」）は、あなた（「クライアント」または「サービスプロバイダー」、「あなた」）と私たちとの間の法的拘束力のある契約（「契約」）を構成し、tobook.linkへのアクセスと利用および製品またはサービスの購入から生じる法的関係を規定しています（「サービス」）。これらの規約を注意深く読んでください。tobook.linkのインストール、使用、登録、アクセスにより、これらの規約のすべてを遵守することに明示的に同意するものとします。</p>
    <p>これらの規約の印刷またはコピーを保存しておくことをお勧めします。規約の最新版は常にtobook.linkアプリケーション内で利用可能です。規約の最終改訂日は上記に記載されています。</p>
    <p>tobook.linkアプリケーションに登録していない個人は、アプリケーション内の一部の機能のみを閲覧および使用することができますが、アプリケーションの一部の機能は使用できません。</p>
    <h6 class="mt-5 mb-3">
      1. サービスの一般的な説明
    </h6>
    <p>1.1. tobook.linkのウェブサイト、モバイルアプリケーション、およびウェブウィジェットは、クライアントが望むサービスプロバイダーから特定のサービスを予約するために使用できる電子予約システムです（「サービスプロバイダー」）。可能なサービスの種類は無制限で、絶えず拡大しています。</p>
    <p>1.2. 予約システムの提供者として、私たちはtobook.linkアプリケーションに記載されているサービスを配達、提供、管理、提供、または所有していません。クライアントがサービスを注文し、サービスプロバイダーが予約されたサービスを確認すると（「tobook.link」）、当事者間で契約が成立し、tobook.linkはこの契約（「契約」）の当事者とはみなされません。同様に、tobook.linkはサービスプロバイダーとクライアント間の契約関係の当事者でもありません。</p>
    <h6 class="mt-5 mb-3">
      2. 利用規約
    </h6>
    <p>2.1. ウェブサイト、モバイルアプリケーション（「tobook.link」）への使用および登録（アカウント作成）は無料です。</p>
    <p>2.2. クライアントとして登録なしでウェブサイト（「tobook.link」）にアクセスして使用することができます。ただし、サービスプロバイダーになりたい場合は、登録プロセスを経てアカウントを作成する必要があります。</p>
    <p>2.3. 18歳に達した個人はtobook.linkにアカウントを登録することができます。</p>
    <p>2.4. 登録時には、自分自身について正確で真実、正しい情報を提供し、変更があった場合は更新する必要があります。必要なデータに関するより詳細な情報については、プライバシーポリシーを参照してください。</p>
    <p>2.5. アカウントの登録および認証は、あなたの電話番号とメールアドレスを使用して行われます。</p>
    <p>2.6. サービスプロバイダーは、ログイン情報を開示してはなりません。サービスプロバイダーはこれらの情報を保持し、情報が自分だけに知られ、使用されることを確実にする必要があります。他の個人にこれらの情報を開示したり、他の個人がアクセスしたり使用したりすることを許可してはなりません。ログイン情報が紛失、盗難、またはその他の方法で悪用されたり、第三者がアクセス可能であると疑う理由がある場合は直ちに私たちに通知してください。ユーザーの識別コードを使用して実行されたすべての操作は、ユーザーによって実行された操作と見なされ、ユーザーはそのような操作の結果について完全な責任を負うものとします。</p>
    <h6 class="mt-5 mb-3">
      3. サービスの予約
    </h6>
    <p>3.1. 予約する前に、クライアントはサービスが自分のニーズを満たしていることを確認する必要があります。</p>
    <p>3.2. クライアントはアプリケーションに提供されている連絡先情報を使用してサービスプロバイダーに連絡することができます。</p>
    <p>3.3.  サービスを予約する際には、日付と時間の予約リクエストがサービスプロバイダーに送信されます。クライアントは、予約の確認をメールまたはメッセージで受け取るべきです。</p>
    <p>3.4 現在の予約情報は、サービスプロバイダーの個人アカウントで利用可能です。</p>
    <h6 class="mt-5 mb-3">
      4. サービスプロバイダーのサービスに対する支払い
    </h6>
    <p>4.1. 支払いプロバイダー</p>
    <ul>
      <li>Tobook.linkは、第三者の支払いプロバイダー（以下、「支払いプロバイダー」と呼ぶ）を通じて、サービスプロバイダーの個人アカウントへ直接支払いを処理します。Tobook.linkは支払いプロバイダーのサービスの可用性とセキュリティを確保するために合理的な予防策を講じますが、支払いプロバイダーのサービスへのアクセスが中断または連続しないこと、または支払いプロバイダーがウイルスやエラーを完全に免れているとは保証できません。</li>
    </ul>
    <p>4.2. 責任</p>
    <ul>
      <li>サービスプロバイダーは、支払いプロバイダーを通じてサービスの支払いをするクライアントの権利を維持する責任を単独で負います。</li>
      <li>支払いまたはデポジットの徴収がサービスプロバイダーのサービスが提供される国の法律に違反する場合、サービスプロバイダーは予約ページ上での支払いまたはデポジット機能を有効にしてはなりません。それ以外の場合、サービスプロバイダーは単独で責任を負います。</li>
      <li>Tobook.linkは、支払いプロバイダーによるエラーに対しては責任を負いません。修理、メンテナンス、または新しい設備やサービスの導入のために、支払い処理へのアクセスが時々制限される場合があります。計画された中断については合理的な事前通知を提供し、できるだけ早く施設の運営を復旧するよう努めます。</li>
      <li>サービスプロバイダーは、適用される場合、追加の商品やサービスの販売や割引の調整を含むサービス総費用に対する間接税（売上税、VAT、GST、サービス税など）の支払い責任を単独で負います。</li>
    </ul>
    <p>4.3. サービスプロバイダーによる価格設定</p>
    <ul>
      <li>価格および料金は、支払いプロバイダーの支払いページに表示されます。</li>
      <li>クライアントがサービス提供中にサービスプロバイダーから追加の商品やサービスを購入することによって、クライアントが支払う最終価格は調整される場合があります。</li>
      <li>Tobook.linkはクライアントからのサービスチャージも含まれ、支払いの最終金額に反映されます。</li>
    </ul>
    <p>4.4. サービスプロバイダーのサービスの支払い</p>
    <ul>
      <li>Tobook.linkはサービスプロバイダーを代わって支払いを収集しません。サービスの支払いはクライアントからサービスプロバイダーへの直接支払いとみなされます。支払い処理手数料を除いて、クライアントが支払うことを決定した支払いの100%をサービスプロバイダーが受け取ります。</li>
      <li>クライアントは最終価格で指定された通貨でサービスの支払いを行います。クライアントによって発生した通貨変換コストまたはその他の費用は、支払いに加えてクライアントの責任となります。</li>
    </ul>
    <p>4.5. 税金</p>
    <ul>
      <li>Tobook.linkはサービスプロバイダーに税金を課しません。サービスプロバイダーのサービスはサービスプロバイダーによって提供されるからです。クライアントが支払いプロバイダーを通じて支払いを行う場合、支払いプロバイダーはクライアントのメールに請求書を提供します。</li>
    </ul>
    <p>4.6. 予約の移動</p>
    <ul>
      <li>クライアントが確認後に予約（例えば、時間/日付）を部分的にまたは完全に移動したい場合、関連するサービスプロバイダーに直接連絡することによってそうすることができます。</li>
      <li>クライアントが予約を移動できるのは、サービスプロバイダーによって定義された特定の期間内に予定されていない時間である場合のみです。クライアントが予約を移動できる時点と予定された予約の開始時間との間隔は、各サービスプロバイダーによって個別に決定され、クライアントがサービスプロバイダーに初めて問い合わせた際に通知されます。クライアントは予約を確認する前にキャンセルポリシーを理解することが推奨されます。予約の移動が可能かどうかは、移動を希望する時間でのサービスプロバイダーの利用可能性によります。</li>
    </ul>
    <p>4.7. キャンセルポリシー、ノーショー</p>
    <ul>
      <li>法定権利に加えて、予見できない状況または緊急事態の発生により、クライアントはサービスプロバイダーとの予約をキャンセルする権利を持つ場合があります。予約をキャンセルするには、クライアントはサービスプロバイダーに直接連絡する必要があります。</li>
      <li>サービスプロバイダーは、緊急事態、予見できない状況、またはサービスプロバイダーのポリシーに規定される他の有効な理由により、一方的に予約をキャンセルすることができます。</li>
    </ul>
    <p>4.8. デポジットと予約キャンセル</p>
    <ul>
      <li>サービスプロバイダーは、予約の確認のためにサービス費用の0％から100％までのデポジットを要求することがあります。予約プロセスを完了する前に、クライアントはサービスプロバイダーから直接要求できるサービスプロバイダーの契約について十分に理解することを強く推奨します。デポジットは返金不可の場合があることに注意してください。Tobook.linkは、サービスプロバイダーへのデポジットについては責任を負いません。</li>
      <li>クライアントによって予約キャンセルが行われた場合、デポジットの返金については、サービスプロバイダーのキャンセルポリシーに従って、サービスプロバイダーと直接解決する必要があります。</li>
      <li>サービスプロバイダーが自ら予約をキャンセルした場合、クライアントのデポジットを返金する義務があります。返金が行われない場合、クライアントは問題を解決するために関連する法執行機関に連絡する権利があります。また、当該サービスプロバイダーの予約ページをブロックする措置を講じることができるよう、support@tobook.linkにそのような事案を通知することもできます。</li>
      <li>クライアントへの預金の返金は、サービスプロバイダーとの合意により、取引手数料を含まず、サービス料も発生しません。</li>
    </ul>
    <p>4.9. キャンセルとノーショー</p>
    <ul>
      <li>予約をキャンセルするには、クライアントはサービスプロバイダーに直接連絡することによってのみ行うことができます。予約開始前にクライアントが予約をキャンセルできる時間間隔は、各サービスプロバイダーによって個別に決定されます。</li>
      <li>Tobook.linkは、予約を確認する前に、クライアントが関連するサービスプロバイダーに直接連絡して、キャンセルポリシーを要求することを推奨します。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      5. レビューと評価
    </h6>
    <p>5.1. サービスを受けた後、クライアントはサービスプロバイダーに対してレビューを残すことができ、また評価を提供することもできます。</p>
    <p>5.2. レビューと評価は真実でなければならず、また、粗野で／または卑猥な表現を含んではなりません。</p>
    <h6 class="mt-5 mb-3">
      6. クライアントとサービスプロバイダー間の紛争
    </h6>
    <p>6.1. 提供されたサービスがサービスの説明と完全に一致しない場合、クライアントは最初にサービスプロバイダーに対して、注文されたサービスとその説明に対応するように無料でサービスを提供することを要求する権利を有します。</p>
    <p>6.2. 予約時にクライアントがサービスが自分のニーズを満たさないことを知っていた、または知らなかったとしても知ることができなかった場合、または非適合の理由がサービスを受けるためにクライアントが提供すべきだった不完全な資料による場合、またはクライアントがサービスを受ける準備ができていなかった場合、またはクライアントがサービスを受けるための他の予備条件を満たしていなかった、またはそれについてサービスプロバイダーに事前に連絡しなかった場合、サービスはその説明と不適合であるとは考えられません。</p>
    <p>6.3. サービスプロバイダーがサービスの提供の結果、クライアントの健康と／または財産に損害を与えた場合、クライアントはそのようなサービスによって引き起こされた損害の賠償を求めて裁判所に訴える権利があります。</p>
    <p>6.4. 紛争の問題についてクライアントとサービスプロバイダーの間で合意に達することができない場合、クライアントは消費者権利保護センターに連絡して紛争を解決する権利があります。</p>
    <p>6.5. クライアントまたはサービスプロバイダーが消費者権利保護センターの決定に同意しない場合、当事者は法律に基づいて紛争が解決される裁判所に訴える権利があります。</p>
    <p>6.6. ヨーロッパ委員会は代替紛争解決（ADR）のためのプラットフォームを提供しており、これは http://ec.europa.eu/odr で利用可能です。</p>
    <h6 class="mt-5 mb-3">
      7. 責任および免責事項
    </h6>
    <p>7.1. サイトまたはtobook.linkのコンテンツに対する不満に対するあなたの唯一の救済策は、サイトまたはそのようなコンテンツの使用を停止することです。この救済制限は、当事者間の契約の一部です。</p>
    <p>7.2. tobook.linkは、サイトまたはコンテンツ、サービス、またはサイトの機能がエラーなく中断されず、欠陥が修正され、サイトの使用によって特定の結果が得られることを約束するものではありません。サイトとそのコンテンツは「現状のまま」および「利用可能な状態」で提供されます。</p>
    <p>7.3. tobook.linkは、いかなる場合においても、あなたに対して間接的な、結果的な、模範的な、付随的な、または懲罰的な損害（利益の喪失を含む）の責任を負わないものとします。たとえtobook.linkがそのような損害の可能性について通知を受けていた場合でも、これに限りません。</p>
    <p>7.4. これらの利用規約の他の規定にもかかわらず、tobook.linkがサイトまたは当社のアプリの使用に起因するあなたの損害や損失について責任を負う場合、tobook.linkの責任は、初回の請求の日から6ヶ月以内に支払われたサービスまたは機能に関連するいかなる購読料または同様の料金の合計額を超えないものとします。</p>
    <p>7.5. tobook.linkは、火災、洪水、戦争、騒乱、ストライキ、ロックアウト、自然災害、停電、コンピュータウイルス、その他のtobook.linkの制御を超える事象による義務の不履行または遅延した履行に対して一切の責任を負いません。</p>
    <p>7.6. tobook.linkは、いかなるサービスプロバイダーのサービスの品質、セキュリティ、適合性、サービスの説明の正確性、評価、その他の関連情報の品質、真実性、正確性をも管理または保証するものではありません。tobook.linkは、サービスプロバイダーが登録したサービス（品質や適合性を含む）をチェックしません。サービスプロバイダーの評価、フィードバック、その他の関連情報は、tobook.linkがサービスの品質や適合性を保証するものではありません。tobook.linkはただ電子的なサービスの予約を提供するだけですので、どのサービスプロバイダーを選ぶかを決定する際には、注意してすべての情報をよく確認してください。</p>
    <p>7.7. 法律において最大限許される範囲で、あなたはtobook.link、その従業員、および関連会社を、tobook.linkのウェブサイト、モバイルアプリケーション（「tobook.link」）、およびウェブウィジェットへのユーザーのアクセスまたは使用に関連するすべてのクレーム、責任、損失、費用（法的費用を含む）から保護し、これらに対して弁護し、免責するものとします。</p>
    <p>7.8. tobook.linkは、正確性、非侵害性、商業性、特定の目的への適合性を含む、明示または黙示のいかなる保証も放棄します。</p>
    <p>7.8.1 tobook.linkは、サイトからダウンロードするファイルや他のデータにウイルス、汚染物質、または破壊的な機能が含まれていないことを保証できないものとします。</p>
    <p>7.9 tobook.linkは、サイトやtobook.linkのサービスと関連するいかなる第三者の行為、遺漏、および行為に対しても責任を負いません。</p>
    <h6 class="mt-5 mb-3">
      8. 適用法および紛争解決
    </h6>
    <p>8.1. 必須の消費者保護規制の適用を優先することを除き、これらの利用規約はチェコ共和国の法律に基づいて規制されるものとします。</p>
    <p>8.2. ユーザーとtobook.linkとの間で契約の規定に起因する紛争が発生した場合、ユーザーは名前と連絡先情報、クレームの提出日、およびその理由を明示した書面または電子的な手段でクレームを提出する権利を有します。当社は15日以内にクレームに対して回答します。</p>
    <p>8.3. 交渉を通じて紛争を解決できない場合、いずれの当事者もチェコ共和国の裁判所に紛争を提訴する権利を有します。提訴はチェコ共和国の法律に従って行われます。</p>
    <h6 class="mt-5 mb-3">
      9. 知的財産
    </h6>
    <p>9.1. ウェブサイト、モバイルアプリケーション（「tobook.link」）およびウェブウィジェットのコンテンツは、画像、ビデオ、ロゴ、メニュー、ウェブサイト、グラフィックス、色彩、ツール、デザイン、方法、機能、およびアプリの運営を支援するすべてのソフトウェアを含む、当社とその他の権利者に帰属する著作権およびその他の知的財産権によって保護されています。コンテンツの全部または一部の複製、およびあらゆる形態の複製は禁止されています。</p>
    <p>9.2. ユーザーは、アプリとそのコンテンツを閲覧することが許されています。ユーザーは、ウェブサイト、モバイルアプリケーション（「tobook.link」）およびウェブウィジェットの閲覧およびそのコンテンツの一部である一時的な複製活動（一時的な性格を有し、ウェブサイトの閲覧とそのコンテンツの重要な部分である）を個人使用のために行うことが許されます。ウェブサイト、モバイルアプリケーション（「tobook.link」）およびウェブウィジェットに掲載されている作品の著作者は、自身の作品の著作者であり、作品の改変や変形、名誉や評判を傷つける可能性のある作品を含む、作品の改変や変形に対する著作者としての権利を主張する権利を有します。</p>
    <p>9.3. アプリで購入するサービスを識別する商標は、それぞれの所有者の登録商標であり、アプリ上でのサービスの説明と宣伝に使用されます。当社およびその他の登録商標所有者には、所有する商標を使用する独占的な権利があります。このような商標の違法または無許可の使用は禁止されており、重大な法的な結果を引き起こす可能性があります。</p>
    <p>9.4. 公開されているウェブページでアプリのコンテンツへのリンクを使用する場合には、以下のアドレスに電子メールを送信して当社にお問い合わせください：support@tobook.link。</p>
    <h6 class="mt-5 mb-3">
      10. 契約の有効性と終了
    </h6>
    <p>10.1. この契約は終了するまで有効です。</p>
    <p>10.2. ユーザーはいつでも契約を終了できます。その際には、アプリでの登録（アカウントの削除）を終了し、アプリへのアクセスと使用を終了し、デバイスからアプリを削除することで契約を終了することができます。GDPRに準拠して、ユーザーは「忘れられる権利」としても知られる削除の権利を持っています。したがって、リクエストに基づき、当社は収集したすべての個人データを削除します。</p>
    <p>10.3. ユーザーが契約を終了する場合、すべての現在のサービス予約は自動的にキャンセルされ、予約のキャンセルおよび払い戻し条件（予約のキャンセルおよび払い戻し条件）に従って払い戻しされます。</p>
    <p>10.4. 以下の事情および前提条件が、tobook.linkがユーザーのtobook.linkへのアクセスを制限、一時停止、または拒否することを十分な理由とします（重大なまたは繰り返された禁止行為の場合）：</p>
    <ul>
      <li>法的要件。</li>
      <li>ユーザーが適用される法律に違反しているとの理由。</li>
      <li>利用規約のいかなる要件の違反。</li>
      <li>ユーザーへのクレーム、繰り返された予約のキャンセル。</li>
      <li>アプリや第三者のセキュリティに対する脅威となるユーザーによるアプリの常時使用との理由。</li>
      <li>詐欺またはその他の違法行為の防止。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      11. 最終規定
    </h6>
    <p>11.1. tobook.linkは、適用される法律および規制の変更による場合を含め、いつでも利用規約を変更する権利を留保します。利用規約の最終改定日は上記に示されています。ユーザーは、利用規約の変更を拒否し、契約を終了することができます。その場合、以前のバージョンの利用規約への同意が有効であり、あなたと当社の間の任意の紛争に適用されます。ウェブサイト、モバイルアプリケーション（「tobook.link」）およびウェブウィジェットとそのサービスへのアクセスまたは使用を続けることにより、利用規約の変更に同意するものとします。</p>
    <p>11.2. 当社の意見では、利用規約の変更が重要な場合、tobook.linkは変更が発効する1（1）カレンダー月前にユーザーに通知します。ただし、以下の場合はこの規定に関係なく、利用者にとって（i）より有利な変更である場合、（ii）法律で要求される場合、または（iii）新しいサービスの追加、または既存のサービスへの追加機能の場合、（iv）ユーザーの権利を減少させるものではなく、ユーザーの責任を増大させない場合、即座に効力を生じるものとします。</p>
    <h6 class="mt-5 mb-3">
      12. カスタマーサポートサービスおよび連絡先
    </h6>
    <p>12.1. 質問がある場合は、以下の連絡オプションを使用して
      <b-link
        :to="{name: 'partners'}"
      >tobook.link</b-link>にお問い合わせください。ヘルプセクションの「ヘルプを取得」の下に連絡オプションがあります。</p>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'JaTermsOfUse',
  components: {
    BLink,
  },
}
</script>

<style scoped>

</style>
